import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StyledWrapper from "./style";
import { LOGIN } from "../../../constants/routes";

export default function AddFinalMessage() {
  let navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(LOGIN);
    }, 5000);
  });

  return (
    <div className="h-screen">
      <StyledWrapper.Card>
        <StyledWrapper.CardContent>
          <p className="text-xl md:text-3xl text-center font-bold text-[#DF6865]">
            ¡Listo! ya creamos tu cuenta
          </p>
          <StyledWrapper.ButtonType>
            <StyledWrapper.Border>
              <StyledWrapper.Inside />
            </StyledWrapper.Border>
          </StyledWrapper.ButtonType>
          <p className="mt-10 text-base md:text-xl text-center ">
            En unos segundos te enviaremos un link a tu casilla de mail, para
            validar tu identidad
          </p>
        </StyledWrapper.CardContent>
      </StyledWrapper.Card>
    </div>
  );
}
